<template>
    <v-tab-item class="fill-height">
        <div class="text-center mb-20 mb-lg-40">
            <h3 class="tit mb-8 mb-lg-16">미팅 가능시간 설정</h3>
            <p class="page-text--lg grey-6--text">면접이 가능한 날짜와 시간을 순서대로 선택한 후 다음 단계로 넘어가 주세요.</p>
        </div>

        <v-sheet class="pa-10">
            <vertical-form-table v-model="meeting" v-bind="{ items }" class="mb-20 mb-lg-40" @input="emit" />
            <listed-datetime-picker v-model="meeting.schedulesAvailable" multiple @input="emit" />
        </v-sheet>

        <meeting-schedules-card :meeting="value" />

        <div class="v-btn-group">
            <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="$emit('prev')">
                <span class="grey-6--text">이전으로</span>
            </v-btn>
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ disabled }" @click="$emit('next')">
                <span>저장 후 다음으로</span>
            </v-btn>
        </div>

        <!-- <v-layout column align-center fill-height style="overflow-y: hidden">
            <v-card-title class="font-size-26 font-size-md-30 font-size-lg-36">미팅 가능시간 설정</v-card-title>
            <v-card-subtitle class="page-text--lg pt-16 pb-40 grey-6--text">면접이 가능한 날짜와 시간을 순서대로 선택한 후 다음 단계로 넘어가 주세요.</v-card-subtitle>
            <v-card-text class="d-flex flex-column" style="position: relative; flex: 1 1 auto; overflow-y: hidden">
                <v-sheet style="overflow-y: auto" class="pa-10">
                    <vertical-form-table v-model="meeting" v-bind="{ items }" @input="emit" />
                    <listed-datetime-picker v-model="meeting.schedulesAvailable" multiple @input="emit" />
                </v-sheet>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn outlined @click="$emit('prev')"> 이전으로</v-btn>
                <v-btn color="primary" @click="$emit('next')"> 저장 후 다음으로 </v-btn>
            </v-card-actions>
        </v-layout> -->
    </v-tab-item>
</template>

<script>
import dayjs from "dayjs";
import { attrs_input, initMeeting } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import ListedDatetimePicker from "@/components/dumb/listed-datetime-picker.vue";
import MeetingSchedulesCard from "@/components/dumb/meeting-schedules-card.vue";

const items = [
    {
        key: "title",
        type: "text",
        term: "면접 제목",
        required: true,
        placeholder: "면접 제목을 입력하세요",
    },
    {
        key: "matching",
        type: "dates",
        term: "면접 매칭 가능일",
        required: true,
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        VerticalFormTable,
        ListedDatetimePicker,
        MeetingSchedulesCard,
    },
    props: {
        value: { type: Object, default: initMeeting }, // meeting
    },
    data: () => ({
        meeting: initMeeting(),

        items,
    }),
    computed: {
        disabled() {
            if (!this.meeting.title) return true;
            if (!this.meeting.matching.startsAt) return true;
            if (!this.meeting.matching.endsAt) return true;
            if (!this.meeting.schedulesAvailable.length) return true;
            return false;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        async sync() {
            this.meeting = { ...initMeeting(), ...this.value };
        },
        async emit() {
            let { title, matching, schedulesAvailable } = this.meeting;
            this.$emit("input", { ...this.value, title, matching, schedulesAvailable: schedulesAvailable.sort((a, b) => (dayjs(a).isAfter(b) ? 1 : -1)) });
        },
    },
};
</script>

<style></style>
